import { Directive, OnDestroy, OnInit, Optional } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";

@Directive({
    selector: '[closeOnEscape]',
    standalone: true
})

export class CloseOnEscapeDirective implements OnInit, OnDestroy {
    private keydownSubscription: Subscription;

    constructor( @Optional() private dialogRef: MatDialogRef<any>) {}

    ngOnInit() {
        if(!this.dialogRef) {
            return;
        }
        this.keydownSubscription = this.dialogRef.keydownEvents().subscribe(event => {
            if (event.key === 'Escape') {
                this.dialogRef.close();
            }
        });
    }
    ngOnDestroy(): void {
        this.keydownSubscription?.unsubscribe();
    }
}